module.exports = __webpack_public_path__ + "a54dc8db6d0a82af68fba0e32fbd60e9.png";